import type { KyInstance, Options } from "ky";

import { HTTPError, default as kyLib } from "ky";

import { getEnv } from "./solvariEnv.ts";

const ky: KyInstance = kyLib.create({
  credentials: "include",
  headers: { accept: "application/json" },
  hooks: {
    afterResponse: [
      (_request, _options, response) => {
        if (response.status === 401) {
          const redirectUrl = getEnv().network.auth.baseWithPrefix;

          if (!window.location.href.includes(redirectUrl)) {
            window.location.href = redirectUrl;
          }
        }
      },
    ],
  },
});

const kyNoCredentials: KyInstance = kyLib.create({
  headers: { accept: "application/json" },
});

export { HTTPError, ky, kyNoCredentials, type Options as KyOptions };
